// update a rule (name and description only)
import { gql, TypedDocumentNode } from "@apollo/client";

import {
  UpdateRuleMutation,
  UpdateRuleMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { ruleFragment } from "src/graphql/anti-fraud/fragments/RuleFragment";

export const updateRuleMutation = gql`
  mutation UpdateRule($id: ID!, $name: String!, $description: String!) {
    updateRule(id: $id, options: { name: $name, description: $description }) {
      ...RuleFragment
    }
  }

  ${ruleFragment}
` as TypedDocumentNode<UpdateRuleMutation, UpdateRuleMutationVariables>;
